import { NgModule, LOCALE_ID } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { CookieModule } from 'ngx-cookie';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { provideNgxWebstorage, withNgxWebstorageConfig, withSessionStorage  } from 'ngx-webstorage';
import { NgJhipsterModule, translatePartialLoader, missingTranslationHandler } from 'app/ng-jhipster/ng-jhipster.module';
import { JhiConfigService } from 'app/ng-jhipster/config.service';
import locale from '@angular/common/locales/en';

import moment from 'moment';
import { NgbDateAdapter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateMomentAdapter } from 'app/shared/util/datepicker-adapter';

@NgModule({ imports: [CookieModule.forRoot(),
        //NgxWebstorageModule.forRoot({ prefix: 'jhi', separator: '-' }),
        NgJhipsterModule.forRoot({
            // set below to true to make alerts look like toast
            alertAsToast: false,
            alertTimeout: 30000,
            i18nEnabled: true,
            defaultI18nLang: 'en'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translatePartialLoader,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useFactory: missingTranslationHandler,
                deps: [JhiConfigService]
            }
        })], providers: [     
        // ⬇️ Correct: pass the feature created by withNgxWebstorageConfig(...)
            
        provideNgxWebstorage(
            withNgxWebstorageConfig({
            prefix: 'jhi',
            separator: '-',
            caseSensitive: true
            }),
            withSessionStorage()   // ← THIS FIXES "No provider for SessionStorageService"
        ),

        Title,
        {
            provide: LOCALE_ID,
            useValue: 'en'
        },
        { provide: NgbDateAdapter, useClass: NgbDateMomentAdapter },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class FinitoCoreModule {
  constructor(private dpConfig: NgbDatepickerConfig) {
    registerLocaleData(locale);
    this.dpConfig.minDate = { year: moment().year() - 100, month: 1, day: 1 };
  }
}
